import React from 'react';

const baseRoutes = [
    {
        path: '/single/question/:questionId',
        exact: true,
        element: React.lazy(() => import('@/pages/single-quesion')),
    },
    {
        path: '/demo',
        exact: true,
        element: React.lazy(() => import('@/pages/demo')),
    },
    {
        path: '/do-question',
        exact: true,
        element: React.lazy(() => import('@/pages/do-question')),
    },
    {
        path: '/see-analysis',
        exact: true,
        element: React.lazy(() => import('@/pages/see-analysis')),
    },
    {
        path: '/',
        exact: true,
        element: React.lazy(() => import('@/pages')),
    },
    {
        path: '/paper',
        exact: true,
        element: React.lazy(() => import('@/pages/demo')),
    },
];

export { baseRoutes };
